import { Component, Inject, Injector, OnDestroy, OnInit, Optional, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'app/core/services/config.service';
import { OktaService } from 'app/core/services/okta.service';
import { RequestService } from 'app/core/services/request.service';
import { StorageService } from 'app/core/services/storage.service';
import { UtilService } from 'app/core/services/util.service';

@Component({
  template: `<div>{{error}}</div>`
})
export class OktaCallbackComponent implements OnInit, OnDestroy {

  error?: string;

  constructor(
    private oktaService: OktaService,
    private utilService: UtilService,
    private renderer: Renderer2,
    private router: Router,
    private requestService: RequestService,
    private configService: ConfigService,
    private storageService: StorageService,
    @Optional() private injector?: Injector,
  ) {}

  async ngOnInit(): Promise<void> {
    // const config = this.oktaService.client();

    this.utilService.hidePartials();
    this.setBackground();

    if (!this.oktaService.client) {
      throw new Error('Okta config is not provided');
    }
    try {
      // Parse code or tokens from the URL, store tokens in the TokenManager, and redirect back to the originalUri
      await this.oktaService.client.handleLoginRedirect();
      this.setSessionCookie();
      window.location.replace(`${window.location.origin}`);
    } catch (e) {
      // Callback from social IDP. Show custom login page to continue.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore Supports auth-js v5 & v6-7
      const isInteractionRequiredError = this.oktaService.client.isInteractionRequiredError || (this.oktaService.client.idx && this.oktaService.client.idx.isInteractionRequiredError);
      if (isInteractionRequiredError(e) && this.injector) {
        // const { onAuthResume, onAuthRequired } = config;
        // const callbackFn = onAuthResume || onAuthRequired;
        const callbackFn = this.oktaService.onAuthRequired;
        if (callbackFn) {
          callbackFn(this.oktaService.client, this.injector);
          return;
        }
      }
      this.error = (e as Error).toString();
    }
  }

  setSessionCookie() {
    const oktaTokenStorage = this.storageService.get('okta-token-storage');
    const accessTokenData = oktaTokenStorage && oktaTokenStorage['accessToken'];
    const refreshToken = oktaTokenStorage && oktaTokenStorage['refreshToken'];
    const claims = accessTokenData && accessTokenData['claims'];
    const accessToken = accessTokenData && accessTokenData['accessToken'];
    const authTime = this.oktaService.decodeToken(accessToken).auth_time;

    const cookiePayload = {
      username: claims.mkpEmail,
      domain: claims.mkpDomain,
      authAt: authTime,
      expiresAt: refreshToken.expiresAt,
      initiator: window.location.origin
    }
    const cookieDomain = this.configService.get('server').sahara.split('my.')[1]
    this.setCookie("mkp-session", JSON.stringify(cookiePayload), cookieDomain, refreshToken.expiresAt*1000)
  }

  setCookie(cname, cvalue, domain, expiresAt) {
    const d = new Date();
    d.setTime(expiresAt);
    let expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/;domain=.${domain}`;
  }

  ngOnDestroy(): void { 
    this.utilService.showPartials();
    this.removeBackground();
  }

  setBackground() {
    this.renderer.setStyle(document.body, 'background-color', '#f7f7f7');
  }

  removeBackground() {
      this.renderer.removeStyle(document.body, 'background-color');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/okta-callback/okta-callback.component.ts